import * as React from 'react';
import {
    TextField,
    TopToolbar,
    useRefresh,
    RichTextField,
    SimpleShowLayout,
    Show,
} from 'react-admin';

import ThumbnailField from '../../common/ThumbnailField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { FileUpload, Today } from '@mui/icons-material';
// @ts-ignore
import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { LoadingSection } from '../../common/LoadingSection';
import NonCategoryProductList from '../non_category_products/NonCategoryProductList';
import { useParams } from 'react-router';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import { ScheduleForm } from './batch-schedules/ScheduleForm';
import { BatchScheduleCalender } from './batch-schedules/BatchScheduleCalender';
import { BatchScheduleTabular } from './batch-schedules/BatchScheduleTabular';
import { BatchTopicsList } from './batch-topics/BatchTopicsList';
import useBatchById from '../../hooks/useBatches';
import BatchScheduleTemplates from './BatchScheduleTemplates';
import AssignedEcomProductList from '../../common/ecom-products/AssignedEcomProductList';
import CommonModal from '../../common/ui/CommonModal';
import BulkUploadCreate from '../bulk-uploads/BulkUploadCreate';

const Actions = ({ onSuccess, batch, onScheduleRefresh }: any) => {
    const [open, setOpen] = useState(false);
    const [bulkUploadModal, setBulkUploadModal] = useState(false);
    const refresh = useRefresh();
    return (
        <div className="py-3">
            <TopToolbar>
                <Button
                    onClick={() => {
                        setOpen(true);
                    }}
                    startIcon={<Today />}
                >
                    Add a Schedule
                </Button>
                <AssignEcomProductModal
                    type="batch"
                    typeId={batch?.id}
                    title="Assign Batch"
                    onSuccess={onSuccess}
                />
                <div className="flex text-sm font-semibold p-2  gap-2 justify-start text-[#4f3cc9]  items-center cursor-pointer hover:bg-blue-50">
                    <button
                        onClick={() => setBulkUploadModal(true)}
                        className="flex items-center uppercase gap-2"
                    >
                        <FileUpload fontSize="small" /> Bulk Assign
                    </button>
                </div>
            </TopToolbar>

            <Dialog
                open={open}
                title={'Schedule Form'}
                onClose={(_refresh: boolean) => {
                    setOpen(false);
                }}
            >
                <ScheduleForm
                    batchId={batch?.id}
                    templateId={batch?.templateId}
                    onClose={(_refresh: boolean) => {
                        if (_refresh) {
                            refresh();
                            if (onScheduleRefresh) {
                                onScheduleRefresh();
                            }
                        }
                        setOpen(false);
                    }}
                />
            </Dialog>
            <CommonModal
                title="Assign Student Bulk Upload"
                open={bulkUploadModal}
                setOpen={setBulkUploadModal}
            >
                <BulkUploadCreate selectedType="BATCH_STUDENT" />
            </CommonModal>
        </div>
    );
};

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} {...other}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const BatchScheduleSwitchWrapper = ({ batch, refreshKey }: { batch: any; refreshKey: any }) => {
    const [value, setValue] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Calender" />
                    <Tab label="Tabular View" />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <BatchScheduleCalender batch={batch} refreshKey={refreshKey} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <BatchScheduleTabular batch={batch} refreshKey={refreshKey} />
            </TabPanel>
        </Box>
    );
};

export const BatchProductCard = () => {
    let { id } = useParams();

    return <NonCategoryProductList batchId={id as string} />;
};

BatchProductCard.defaultProps = {
    source: 'batch_id',
    label: 'Product',
};

const BatchShow = () => {
    const [activeTab, setActiveTab] = useState(0);
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();
    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { id } = useParams();
    if (!id) {
        return <LoadingSection />;
    }
    const { batch, loading, error } = useBatchById({ id });

    const tabData = [
        {
            label: 'Details',
            content: (
                <div>
                    <SimpleShowLayout record={batch}>
                        <ThumbnailField size={'large'} source="image" />
                        <TextField source="title" />
                        <TextField source="displayOrder" />
                        <FormattedDateTimeField source="startTime" />
                        <FormattedDateTimeField source="endTime" />
                        <TextField source="status" />
                        <TextField source="textDescription" />
                        <RichTextField source="htmlDescription" />
                    </SimpleShowLayout>
                </div>
            ),
        },

        {
            label: 'Product Details',
            content: (
                <Show actions={<></>} id={id} resource={'batches'}>
                    <AssignedEcomProductList type="batch" typeId={id} refreshKey={refreshKey} />
                </Show>
            ),
        },
        {
            label: 'Schedules',
            content: <BatchScheduleSwitchWrapper batch={batch} refreshKey={refreshKey} />,
        },
        {
            label: 'Topics',
            content: (
                <div>
                    <BatchTopicsList batch={batch} />
                </div>
            ),
        },
        {
            label: 'Students',
            content: (
                <div>
                    <AssignedUserList type="batches" typeId={id} refreshKey={refreshKey} />
                </div>
            ),
        },
        {
            label: 'Schedule Templates',
            content: (
                <>
                    <BatchScheduleTemplates batch={batch} />{' '}
                </>
            ),
        },
    ];

    return loading ? (
        <LoadingSection />
    ) : error ? (
        <div>Error loading batch details</div>
    ) : (
        <div className="rounded-md border">
            <Actions
                onSuccess={handleAssignSuccess}
                batch={batch}
                onScheduleRefresh={handleAssignSuccess}
            />
            <div className="border-b py-2 flex text-lg flex-row gap-16 px-10 mb-6 rounded-t-md bg-white">
                {tabData.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => handleTabClick(index)}
                        className={`hover:cursor-pointer ${
                            index === activeTab
                                ? 'text-[#4f3cc9] underline decoration-4 underline-offset-[10px]'
                                : ''
                        }`}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>

            <div className="tab-content bg-white px-2 pb-6">{tabData[activeTab].content}</div>
        </div>
    );
};

export default BatchShow;
